import React, { useRef, useEffect } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './LoginModal.css';
import api from '../services/api';

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    // Add event listener for clicking outside the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener for ESC key
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  // Handle Google sign-in success
  const handleGoogleSuccess = async (response) => {
    console.log('Google Sign-In Successful!');
    
    // The response contains a credentials key with the JWT token
    const jwt = response.credential;
    
    try {
      // JWT tokens are formatted as header.payload.signature
      // We need the payload part (index 1)
      const payload = jwt.split('.')[1];
      
      // Base64 decode the payload 
      const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      
      // Parse the decoded JSON
      const userData = JSON.parse(decodedPayload);
      
      console.log('User email:', userData.email);
      console.log('Authenticating with backend...');
      
      // Send the user data to our backend for authentication
      const authResult = await api.authenticateWithGoogle(userData);
      
      if (authResult.success) {
        console.log('Backend authentication successful, storing user data');
        
        // Log the user data we received to ensure it has all fields
        console.log('User data to store:', authResult.user);
        
        // Verify the required subscription fields
        if (authResult.user.trial_end_date === undefined) {
          console.warn('Warning: trial_end_date is missing from user data!');
        }
        
        if (authResult.user.subscription_active === undefined) {
          console.warn('Warning: subscription_active is missing from user data!');
        }
        
        // Store complete user in local storage
        localStorage.setItem('user', JSON.stringify(authResult.user));
        
        // First notify parent of successful login
        if (onLoginSuccess) {
          console.log('Calling onLoginSuccess callback');
          onLoginSuccess(authResult.user);
        }
        
        // Then close modal
        console.log('Closing modal');
        onClose();
      } else {
        console.error('Authentication failed:', authResult.error);
      }
    } catch (error) {
      console.error('Error processing Google login:', error);
    }
  };

  // Handle Google sign-in error
  const handleGoogleError = () => {
    console.error('Google Sign-In Failed');
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay">
      <div className="login-modal-container" ref={modalRef}>
        <div className="login-modal-header">
          <h2>Sign In to PlotGoblin</h2>
          <button className="login-modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="login-modal-content">
          <p className="login-intro-text">
            Continue with your Google account to save your stories and track your progress.
          </p>
          
          <div className="google-login-button-wrapper">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              text="signin_with"
              shape="rectangular"
              width="300"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
